import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import api from '../../api';

import BaseModal from '../../components/BaseModal';
import ButtonPrimary from '../../components/ui/ButtonPrimary';
import ButtonTransparent from '../../components/ui/ButtonTransparent';

import './index.css';

const ChangePasswordModal = (props) => {
  const [password, setPassword] = useState('');

  const submit = (e) => {
    e.preventDefault();
    api.changePassword(props.employee.UUID, password);
    props.onClose();
  }

  const body = (
    <div className="employee-info__body">
      <h2 className="employee-info__title modal__body-title">
        {props.title}
      </h2>
      <form className="employee-info__form form" onSubmit={submit}>
        <div className="form__group">
          <label className="form__label" htmlFor="newPassword">New Password</label>
          <input className="form__input" id="newPassword" type="password" value={password} name="newPassword" onChange={(e) => setPassword(e.target.value)}/>
        </div>
        <div className="employee-info__btn-group form__group">
          <ButtonPrimary 
            className="btn btn--primary"
            name="Change Password" 
            onClick={submit}
            isDisabled={!password}
          />
          <ButtonTransparent 
            className="btn btn--transparent" 
            name="Cancel" 
            onClick={props.onClose} 
          />
        </div>
      </form>
    </div>
  );

  return (
    <BaseModal body={body} footer={null} onClose={props.onClose}/>
  );
}

export default withRouter(ChangePasswordModal);